import Box from '@mui/material/Box';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { GradientTypography } from 'src/components/gradients/GradientTypography';
import { TypographyParagraphed } from 'src/components/TypographyParagraphed';
import { useDateFormatter } from 'src/hooks/useDateFormatter';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { LoadingButton } from 'src/components/buttons/LoadingButton';
import Alert from '@mui/material/Alert';
import { useCheckIn } from 'src/components/tournaments/check-in/CheckInContext';
import {
  WizardElementProps,
  withoutWizardProps,
} from 'src/components/wizard/Wizard';
import { CheckInStore } from './useCheckInDialog';
import { useAuth } from 'src/contexts/AuthContext';
import { useCheckInFunc } from './useCheckInFunc';
import { useState } from 'react';

export const RulesCheckInDialog = withoutWizardProps(
  ({ go }: WizardElementProps<CheckInStore>) => {
    const [error, setError] = useState(false);
    const { rulesAndRegulations, date } = useCheckIn();
    const { userData } = useAuth();
    const { checkInFn: checkInUser } = useCheckInFunc();

    const checkInSelf = async () => {
      try {
        setError(false);
        //if the user has not updated their username, require them to do so
        if (!userData?.username || userData?.username?.length > 25) {
          return go('CreateUsernameDialog');
        }
        await checkInUser(false);
        go('CheckedInDialog');
      } catch (e) {
        console.error(e);
        setError(true);
      }
    };

    const format = useDateFormatter({
      separator: ', ',
    });
    const startDateFormatted = format(date);

    return (
      <>
        <DialogTitle>
          <GradientTypography
            gradientColor="primary.vertical"
            variant="h4"
            sx={{ textTransform: 'uppercase' }}
          >
            Tournament Rules
          </GradientTypography>
        </DialogTitle>
        <DialogContent sx={{ backgroundImage: 'none' }}>
          <Box sx={{ textAlign: 'center', backgroundImage: 'none' }}>
            <Typography variant="h6">
              The tournament begins{' '}
              <GradientTypography
                variant="h6"
                gradientColor="warning.vertical"
                sx={{ display: 'inline' }}
              >
                {startDateFormatted}
              </GradientTypography>
              .
            </Typography>
            <Typography variant="h6">
              In order to participate, you must agree to the rules below:
            </Typography>
          </Box>

          {rulesAndRegulations && (
            <Box
              sx={{
                overflowY: 'scroll',
                maxHeight: '200px',
                textAlign: 'left',
                backgroundColor: 'background.elevation.12',
                borderRadius: '10px',
                p: 4,
                mt: 4,
              }}
            >
              <TypographyParagraphed text={rulesAndRegulations} />
            </Box>
          )}
          {error && (
            <Alert severity="error" variant="outlined">
              <Typography
                variant="subtitle1"
                color="error.main"
                sx={{ my: -1, textTransform: 'none' }}
              >
                There was an error when trying to check-in.
              </Typography>
            </Alert>
          )}
        </DialogContent>
        <DialogActions
          sx={{ justifyContent: 'center', pt: 8, px: 0, pb: 0, width: '100%' }}
        >
          <LoadingButton
            type="submit"
            variant="contained"
            size="large"
            color="secondary"
            onClick={async () => {
              await checkInSelf();
            }}
            endIcon={<CheckCircleOutlineIcon />}
            sx={{ flex: 2, mr: 1 }}
          >
            Accept
          </LoadingButton>
          <Button
            variant="contained"
            color="error"
            size="large"
            onClick={() => {
              return go(undefined);
            }}
            sx={{ textTransform: 'uppercase', flex: 1, ml: 1 }}
          >
            Cancel
          </Button>
        </DialogActions>
      </>
    );
  },
);
